import { PaginationRequest } from '@repo/ui/data-table'

import { AccomodationEnum } from '../../../../lib/types/enums/accomodation-type/accomodation-type'
import { EnrollmentCenterFilters } from '../../../../lib/types/models/enrollment-center/enrollment-center'

export const studentCampusResidenceCollegeFilter: PaginationRequest<EnrollmentCenterFilters> = {
  count: true,
  filter: {
    centerAccomodations: [
      AccomodationEnum.CAMPUS,
      AccomodationEnum.RESIDENCE,
      AccomodationEnum.COLLEGE,
      AccomodationEnum.HOTEL
    ]
  }
}

export const studentHostFamilyFilter: PaginationRequest<EnrollmentCenterFilters> = {
  count: true,
  filter: {
    centerAccomodations: [AccomodationEnum.HOST_FAMILY]
  }
}

export const placedHostFamilyFilter: PaginationRequest<EnrollmentCenterFilters> = {
  count: true,
  filter: {
    hasHostFamily: true,
    centerAccomodations: [AccomodationEnum.HOST_FAMILY]
  }
}
